<div class="h-100 mx-2">
  <div *ngIf="isLoading == true" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5"
    [ngClass]="isLoading == false ? 'visible' : 'hidden'">
    <div class="card RegularForm rounded col-12 col-lg-10">
      <div class="card-body MyCardBody rounded-bottom">
        <div class="row mb-md-2 mb-2">
          <div class="col-6">
            <button class="btn btn-primary btn-block" [class.SmallArabicFont]="globalService.isRTL == true"
              (click)="ApplySelectOperation()" type="button">
              <span> {{ getSelectOperationText() }} </span>
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-danger btn-block" [class.SmallArabicFont]="globalService.isRTL == true"
              (click)="confirmDelete = true" [disabled]="isAnySelected() == false" type="button">
              <span> {{ globalService.Get("DELETE") }} </span>
            </button>
          </div>
        </div>
        <div class="col-12" *ngIf="confirmDelete == true">
          <app-confirm-message [showForm]="confirmDelete == true" (onConfirm)="deleteSelection()"
            color="danger" (onCancel)="confirmDelete = false" [message]="globalService.Get('DELETE_NOTIFICATIONS')">
          </app-confirm-message>
        </div>
        <span class="form-control dontselect text-center" style="border-style: none;">
          {{ getSelectedCount() }}
        </span>
        <div *ngFor="let notification of notifications">
          <form #notificationForm="ngForm" [class.SmallArabicFont]="globalService.isRTL == true" class="my-2">
            <input type="hidden" class="form-control" name="id" required #id="ngModel" [(ngModel)]="notification.id" />
            <div class="row">
              <div class="input-group col-12">
                <button class="btn optionButton" [class.pt-2]="globalService.isRTL == true"
                  [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
                  [class.btn-primary]="notification.selected == true"
                  [class.btn-outline-secondary]="notification.selected == false" (click)="ToggleSelection(notification)"
                  type="button">
                  <i class="fas fa-check-circle"></i>
                </button>
                <span class="form-control dontselect notification-date"
                  [ngClass]="notification.isOpen == true ? 'font-weight-normal' : 'semi-bold'">
                  {{ notification.notificationDate }}
                </span>
                <input type="text" class="form-control dontselect notification-title"
                  [ngClass]="notification.isOpen == true ? 'font-weight-normal' : 'semi-bold'" name="title"
                  style="min-width: 50px dontselect notification-title" ngModel [readonly]="true" #fullName="ngModel"
                  [(ngModel)]="notification.title" />

                <button class="btn optionButton btn-secondary ml-2" [class.pt-2]="globalService.isRTL == true"
                  [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
                  (click)="openNotification(notification)" type="button">
                  <i class="fas fa-book-open"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="input-group col-12">
                <input type="text" class="form-control dontselect subtitle" name="subtitle" style="min-width: 50px"
                  ngModel [readonly]="true" #fullName="ngModel" [(ngModel)]="notification.subtitle" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>